import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDocumento, IVerificar, IVerificarDados } from 'src/app/core/models/search';
import { BaseService } from 'src/app/shared/services/base.service';
import { DiplomaSearchService } from 'src/app/shared/services/diploma-search.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar/snack-bar.service';
import { SessionStorageUtils } from 'src/app/shared/utils/session-storage';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {

  private sessionStorage = new SessionStorageUtils();
  public currentDiploma: IVerificarDados = this.sessionStorage.onGetDiploma();  
  isLoading: boolean = false;
  isDocumentLoading: { id: number, isLoading: boolean }[] = [];
  isIframe: boolean = this.baseService.onCheckIframe();
  isSair: boolean = false;
  isDiplomaInativo!: boolean;

  constructor(private router: Router,
              private diplomaService: DiplomaSearchService,
              private snackbar: SnackBarService,
              private baseService: BaseService,
              private activatedRoute: ActivatedRoute) {

    this.isSair = this.activatedRoute.snapshot.data['isSair'];

  }

  ngOnInit(): void {
    if(!this.isSair) this.onSairMode();
    else this.onVerifySession();
    this.currentDiploma.resultadosDaPaginaAtual?.forEach(item => {
      this.isDiplomaInativo = item.situacao?.toLowerCase() === 'inativo' ? true : false;
    });
  }

  onSairMode(){
    this.sessionStorage.onClearSessao();
    this.activatedRoute.queryParams.subscribe((param: any) => {
      (param.codigo || param.token) && this.onVerifyDiploma(Array.isArray(param.codigo) ? param.codigo : [param.codigo], param.token)
    })
    this.onCheckIframe();
  }

  onVerifyDiploma(codeUrl?: string[], token?: string, fromVerifySession?: boolean){    
    if(!codeUrl) {this.router.navigate(['nao-encontrado']); return};
    const code: string[] = codeUrl;
    this.isLoading = true;

    this.diplomaService.onSearchDiploma(code, token).subscribe((data: IVerificar) => {
      this.sessionStorage.onSetDiploma(data.dados);     
      this.sessionStorage.onSetNumberDiploma(code); 
      this.currentDiploma = data.dados;
      this.isLoading = false;
      data.dados.resultadosDaPaginaAtual.forEach((item: IDocumento) => this.isDocumentLoading.push({id: item.id, isLoading: false}));
      fromVerifySession && this.onVerifySession(true);
    },(error: any) =>{ this.isLoading = false; this.router.navigate(['nao-encontrado']); });
    
  }

  onCheckIframe(){
    this.isIframe = this.baseService.onCheckIframe();
  }

  insertDocNumber(){
    this.snackbar.openSnackBar('Insira o número do documento.', 'Fechar', 'error-snackbar')
    this.router.navigate(['']);
  }

  onVerifySession(fromVerifyDiploma?: boolean): void{
    if(!this.currentDiploma || !this.currentDiploma.resultadosDaPaginaAtual || this.currentDiploma.resultadosDaPaginaAtual.length <= 0){

      this.activatedRoute.queryParams.subscribe((param: any) => {
        (param.codigo || param.token) && this.onVerifyDiploma(Array.isArray(param.codigo) ? param.codigo : [param.codigo], param.token, true)
        param.codigo || param.token || this.insertDocNumber();
      })
      fromVerifyDiploma && this.insertDocNumber();
    }
    else{
      this.currentDiploma.resultadosDaPaginaAtual.forEach((item: IDocumento) => this.isDocumentLoading.push({id: item.id, isLoading: false}));
    }
  }

  onGetDownload(event: any, codigo: string, index: number, type: string, modelo: string, action: string){
    event.stopPropagation();
    event.preventDefault();
    this.isDocumentLoading[index].isLoading = true;
    this.isLoading = true;
    
    this.diplomaService.onGetArchive(codigo, type, modelo, action == '' ? '' : 'download').subscribe((data: any) => {      
      this.isDocumentLoading[index].isLoading = false;
      this.isLoading = false;
    },(error: any) => { 
      if(error.avisos && error.avisos.notificacoes.length > 0) this.snackbar.openSnackBar(error.avisos.notificacoes[0].mensagem, 'Fechar', 'error-snackbar');        
      this.isDocumentLoading[index].isLoading = false
      this.isLoading = false;
    });
  }

  onExit(){
    this.sessionStorage.onClearSessao();
    this.router.navigate(['']);
  }

}
